// extracted by mini-css-extract-plugin
module.exports = {"container":"vendorHome_container__NnygT","box":"vendorHome_box__1o97a","box__innerBox":"vendorHome_box__innerBox__3_fqA"};